import { Web, RenderListDataOptions } from "@pnp/sp";
import memoize from "lodash-es/memoize";
import moment from "moment";

import getCurrentPageData from "./currentpage";
import { configuration } from "./config";

const parseDate = str => moment(str, "DD/MM/YYYY");

// eslint-disable-next-line no-undef
const rootWeb = new Web(_spPageContextInfo.siteAbsoluteUrl);

const fakeGetDateRanges = () =>
  Promise.resolve([
    {
      priceRange: "Media",
      dateFrom: moment().subtract(100, "year"),
      dateTo: moment().add(100, "year")
    }
  ]);

const remoteGetDateRanges = memoize(() =>
  getCurrentPageData()
    .then(pageData =>
      rootWeb.lists.getByTitle("ApertureTenute").renderListDataAsStream({
        RenderOptions: RenderListDataOptions.ListData,
        ViewXml: `<View>
      <ViewFields>
        <FieldRef Name="Tenuta" />
        <FieldRef Name="DataDa" />
        <FieldRef Name="DataA" />
        <FieldRef Name="FasciaPrezzo" />
      </ViewFields>
      <Query>
        <Where>
            <Eq>
              <FieldRef Name="Tenuta" />
              <Value Type="TaxonomyFieldType">${pageData.Tenuta.Label}</Value>
            </Eq>
        </Where>
      </Query>
      </View>`
      })
    )
    .then(result =>
      // pick(row, ["DataDa", "DataA", "FasciaPrezzo"]
      result.Row.map(row => ({
        priceRange: row.FasciaPrezzo,
        dateFrom: parseDate(row.DataDa),
        dateTo: parseDate(row.DataA)
      }))
    )
);

export const getDateRanges = configuration.fakeData
  ? fakeGetDateRanges
  : remoteGetDateRanges;
